import storeResourceInteractionsApiCall from '../../../apiCalls/ngs/storeResourceInteractionsApiCall';

function* storeResourceInteractions(orgId, courseId, resourceId, data) {
  yield storeResourceInteractionsApiCall(orgId, courseId, resourceId, data);
}

export default storeResourceInteractions;
